import React, { useContext } from 'react';
import { Context } from 'components/Store';
import GrowUIFormField from 'components/Forms/GrowUIFormField';
import { Input } from '@agconnections/grow-ui';

const Section = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <GrowUIFormField
      placeholder="Enter section"
      control={Input}
      type="text"
      id="section"
      name="section"
      label="Section"
      data-testid="section"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default Section;
